import { ref, nextTick } from 'vue';
import i18n from '@/locales';

/**
 * 导航栏智能计算 Hook
 * 当菜单项超过容器宽度限制时，自动将多余项收纳至 "更多" 下拉菜单
 */
export function useNavCalculation() {
	const navItemsWrapperRef = ref(null);
	const navItemsInnerRef = ref(null);

	const calculatedMenus = ref([]);
	const isCalculated = ref(false);
	const MORE_MENU_WIDTH = 90; // "更多" 按钮预留宽度

	const calculateMenuWidths = async menus => {
		// 重置状态以显示完整列表进行测量
		isCalculated.value = false;
		await nextTick();

		const originalMenus = menus;
		const innerEl = navItemsInnerRef.value;
		const wrapperEl = navItemsWrapperRef.value;

		if (!innerEl || !wrapperEl || !originalMenus || originalMenus.length === 0) {
			calculatedMenus.value = originalMenus || [];
			isCalculated.value = true;
			return;
		}

		const maxNavWidth = wrapperEl.offsetWidth;

		const items = innerEl.children?.length > 0 ? innerEl.children[0].children : []; // 获取 NavMenu ul 下的所有 li 标签
		let totalWidth = innerEl.offsetWidth;

		if (totalWidth <= maxNavWidth) {
			// 宽度足够，直接展示
			calculatedMenus.value = [...originalMenus];
		} else {
			// 宽度不足，需要折叠
			let breakIndex = 0; // 默认为 0，表示全部放入“更多”

			// 获取容器的位置信息，用于计算相对位置
			const containerRect = innerEl.getBoundingClientRect();

			for (let i = 0; i < items.length; i++) {
				const itemRect = items[i].getBoundingClientRect();
				// 计算当前项的右边缘相对于容器左边缘的距离
				const itemEndPos = itemRect.right - containerRect.left;

				// 检查：当前项右边缘位置 + 更多按钮宽度 是否超出
				if (itemEndPos + MORE_MENU_WIDTH > maxNavWidth) {
					breakIndex = i;
					break;
				}
			}

			const visibleItems = originalMenus.slice(0, breakIndex);
			const remainingItems = originalMenus.slice(breakIndex);

			if (remainingItems.length > 0) {
				const firstItem = remainingItems[0];
				const moreMenu = {
					name: i18n.t('enterprise.more'),
					// uuid: firstItem.uuid,
					uuid: 'more', // uuid 是菜单栏的唯一标志，直接沿用 firstItem 的 uuid 会导致重复问题
					displayMode: 1, // 只能是详情模式，因为在 UI 规则上限制了简览模式菜单不能做下拉展开
					menuType: firstItem.menuType,
					menuUrl: firstItem.menuUrl,
					showType: firstItem.showType,
					pageMenuVOS: [...remainingItems]
				};
				calculatedMenus.value = [...visibleItems, moreMenu];
			} else {
				calculatedMenus.value = [...originalMenus];
			}
		}

		isCalculated.value = true;
	};

	return {
		navItemsInnerRef,
		navItemsWrapperRef,
		isCalculated,
		calculatedMenus,
		calculateMenuWidths
	};
}
